import React from 'react';
import { IconProps } from '.';

const SvgArrowTriangleRight = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path fill={color} d='m16.5 12-8 7V5l8 7Z' />
    </svg>
  );
};

export default SvgArrowTriangleRight;
